import React, { useState, useEffect, useMemo } from 'react';
import { products } from '../../data/products';
import './RecentPurchases.css';

interface Purchase {
  name: string;
  location: string;
  time: string;
  image: string;
}

// Danh sách các tỉnh thành miền Nam Việt Nam
const southernProvinces = [
  'TP. Hồ Chí Minh',
  'Bình Dương',
  'Đồng Nai',
  'Bà Rịa - Vũng Tàu',
  'Long An',
  'Tiền Giang',
  'Bến Tre',
  'An Giang',
  'Cần Thơ',
  'Đồng Tháp',
  'Kiên Giang',
  'Cà Mau',
  'Bạc Liêu',
  'Sóc Trăng',
  'Trà Vinh',
  'Vĩnh Long',
  'Tây Ninh',
  'Bình Phước',
];

// Hàm chọn tỉnh thành với xác suất cao hơn cho TP. Hồ Chí Minh
const getRandomProvince = (): string => {
  const random = Math.random();
  // 50% xác suất là TP. Hồ Chí Minh
  if (random < 0.5) {
    return 'TP. Hồ Chí Minh';
  }
  // 50% còn lại là các tỉnh khác
  const otherProvinces = southernProvinces.filter(p => p !== 'TP. Hồ Chí Minh');
  return otherProvinces[Math.floor(Math.random() * otherProvinces.length)];
};

// Tạo danh sách purchases từ sản phẩm thực
const generatePurchases = (): Purchase[] => {
  const times = ['5 phút trước', '12 phút trước', '18 phút trước', '25 phút trước', '32 phút trước', '40 phút trước', '48 phút trước', '55 phút trước'];
  
  // Lấy ngẫu nhiên 8 sản phẩm từ danh sách
  const shuffledProducts = [...products].sort(() => Math.random() - 0.5).slice(0, 8);
  
  return shuffledProducts.map((product, index) => {
    const randomProvince = getRandomProvince();
    const randomTime = times[index % times.length];
    
    // Xử lý image path
    let imageUrl = product.image;
    if (!imageUrl.startsWith('http') && typeof window !== 'undefined') {
      imageUrl = `${window.location.origin}${product.image}`;
    }
    
    return {
      name: product.name,
      location: randomProvince,
      time: randomTime,
      image: imageUrl,
    };
  });
};

const RecentPurchases: React.FC = () => {
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const purchases = useMemo(() => generatePurchases(), []);

  useEffect(() => {
    let currentIndex = 0;

    const showNextPurchase = () => {
      if (purchases.length > 0) {
        setCurrentPurchase(purchases[currentIndex]);
        setIsVisible(true);

        setTimeout(() => {
          setIsVisible(false);
          currentIndex = (currentIndex + 1) % purchases.length;
        }, 5000);
      }
    };

    const firstTimer = setTimeout(showNextPurchase, 60000); // Hiển thị lần đầu sau 1 phút
    const interval = setInterval(showNextPurchase, 60000); // Hiển thị mỗi 1 phút

    return () => {
      clearTimeout(firstTimer);
      clearInterval(interval);
    };
  }, []);

  if (!currentPurchase || !isVisible) return null;

  return (
    <div className={`recent-purchases ${isVisible ? 'active' : ''}`}>
      <div className="purchase-item">
        <img src={currentPurchase.image} alt={currentPurchase.name} />
        <div className="purchase-info">
          <strong>{currentPurchase.name}</strong>
          <span>Ai đó vừa mua từ {currentPurchase.location} {currentPurchase.time}</span>
        </div>
      </div>
    </div>
  );
};

export default RecentPurchases;

